import { render, staticRenderFns } from "./language-button.component.vue?vue&type=template&id=3c01abd4&scoped=true"
import script from "./language-button.component.vue?vue&type=script&lang=js"
export * from "./language-button.component.vue?vue&type=script&lang=js"
import style0 from "./language-button.component.vue?vue&type=style&index=0&id=3c01abd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c01abd4",
  null
  
)

export default component.exports